<template>
  <div class="div">Searched Movies</div>
</template>

<script>
export default {

}
</script>

<style>

</style>